import * as requestFromServer from '../common/cruds'
import { SubscriptionPlanSlices } from './slices'
import { handleNotificationWithToastify } from '../../../app/services/Functional'
import { callTypes, catchError, endCall, startCall } from '../common/slices'

const actions = SubscriptionPlanSlices.actions
const API_URL = `${process.env.REACT_APP_API_BASE_URL}subscription_plans/`
const COUNTRIES_API_URL = `${process.env.REACT_APP_API_BASE_URL}inspection_companies/countries/list`

export const getSubscriptionPlans = () => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .getRequest(`${API_URL}`)
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      dispatch(actions.subscriptionPlans(response.data.data))
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find subscriptions plan'
      dispatch(catchError({ error, callType: callTypes.action }))
    })
}

export const getSubscriptionPlanById = (id: string) => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .getRequest(`${API_URL}${id}`)
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      dispatch(actions.subscriptionPlan(response.data.data))
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find subscription plan'
      dispatch(catchError({ error, callType: callTypes.action }))
    })
}

export const createSubscriptionPlan = (payload: any) => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .postRequest(`${API_URL}`, payload)
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch(error => {
      error.clientMessage = 'Can\'t create subscription plan'
      dispatch(catchError({ error, callType: callTypes.action }))
      return error
    })
}

export const updateSubscriptionPlan = (subscriptionPlan: any) => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .patchRequest(`${API_URL}${subscriptionPlan.id}`, subscriptionPlan)
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch(error => {
      error.clientMessage = 'Can\'t update subscription plan'
      dispatch(catchError({ error, callType: callTypes.action }))
      return error
    })
}

export const subscriptionPlansList = () => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .getRequest(`${API_URL}dropdown`)
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      dispatch(actions.subscriptionPlanList(response.data.data))
    })
    .catch(error => {
      error.clientMessage = 'Can\'t get subscription list'
      dispatch(catchError({ error, callType: callTypes.action }))
    })
}

export const updateSubscriptionPlans = (payload: any) => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .postRequest(`${API_URL}upgrade`, payload)
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch(error => {
      error.clientMessage = 'Can\'t upgrade plan'
      dispatch(catchError({ error, callType: callTypes.action }))
    })
}

export const getFreeAndPaidSubscriptionPlan = () => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.list }));
  return requestFromServer
    .getRequest(`${API_URL}free/paid/plans`)
    .then(response => {
      dispatch(endCall({ callType: callTypes.list }))
      dispatch(actions.freeAndPaidPlanList(response.data.data))
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find sectors'
      dispatch(catchError({ error, callType: callTypes.list }))
    })
}

export const handleselectedSubscriptionPlan = (payload: any) => (dispatch: any) => {
  return dispatch(actions.setSelectedPlan(payload))
}

export const handleReplaceSubscriptionPlan = (payload: any) => (dispatch: any) => {
  return dispatch(actions.setReplacePlan(payload))
}

export const getCountriesList = () => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .postRequest(`${COUNTRIES_API_URL}`)
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      dispatch(actions.countriesList(response.data.data))
    })
    .catch(error => {
      error.clientMessage = 'Can\'t get countries list'
      dispatch(catchError({ error, callType: callTypes.action }))
    })
}